import controller from './products-list.controller';
import templateBase from './templates/products-list-base.view.html';
import templateT1 from './templates/products-list-t1.view.html';
import templateT2 from './templates/products-list-t2.view.html';
import templateT3 from './templates/products-list-t3.view.html';
import templateT4 from './templates/products-list-t4.view.html';
import templateT5 from './templates/products-list-t5.view.html';
import templateT6 from './templates/products-list-t6.view.html';
import templateT10 from './templates/products-list-t10.view.html';
import templateT11 from './templates/products-list-t11.view.html';
import templateT13 from './templates/products-list-t13.view.html';
import templateAD from './templates/products-list-adaptative.html';

let ProductsListComponent = {
    template:changeTemplate,
    controller,
    bindings: {
        shCtrl: '<',
        categorySlug: "<",
        categoryId: '<',
        productsList: '<',
        isProcedure:'<',
        typeview: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
  let response = SessionService.get('components');
  if(__env.adaptative){
    return templateAD;
  } else {
    if (response.PRODUCT_LIST.component == 'template_t1') { return templateT1; }
    else if (response.PRODUCT_LIST.component == 'template_t2') { return templateT2; }
    else if (response.PRODUCT_LIST.component == 'template_t3') { return templateT3; }
    else if (response.PRODUCT_LIST.component == 'template_t4') { return templateT4; }
    else if (response.PRODUCT_LIST.component == 'template_t5') { return templateT5; }
    else if (response.PRODUCT_LIST.component == 'template_t6') { return templateT6; }
    else if (response.PRODUCT_LIST.component == 'template_t10') { return templateT10; }
    else if (response.PRODUCT_LIST.component == 'template_t11') { return templateT11; }
    else if (response.PRODUCT_LIST.component == 'template_t13') { return templateT13; }
    else{
      return templateBase;
    }
  }
}

export default ProductsListComponent;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/products-list/products-list.component.js
 **/